module.exports = __webpack_public_path__ + "media/images/icon_badge-bc6d963855f50ad1412a12c0b5ad7180.svg";